import { vars } from "../utils/variables";

export function getSubscriptionPlans() {
  return [
    {
      _id: vars("monthlyPlanId"),
      name: vars("monthlyPlanName"),
      price: vars("monthlyPlanPrice"),
      productId: vars("monthlyPlanProductId"),
      campaignId: vars("monthlyPlanCampaignId"),
    },
    {
      _id: vars("sixMonthsPlanId"),
      name: vars("sixMonthsPlanName"),
      price: vars("sixMonthsPlanPrice"),
      originalPricePerMonth: vars("sixMonthsOriginalPricePlanPerMonth"),
      pricePerMonth: vars("sixMonthsPlanPricePerMonth"),
      productId: vars("sixMonthsPlanProductId"),
      campaignId: vars("sixMonthsPlanCampaignId"),
    },
    // {
    //     "_id": '123', name : 'CDS Test', price : "2.00", productId : "102"
    // },
    // {
    //     "_id": vars("quarterlyPlanId"), name : vars("quarterlyPlanName"), price : vars("quarterlyPlanPrice"), productId : vars("quarterlyPlanProductId")
    // },
    // {
    //     "_id": vars("annualPlanId"), name : vars("annualPlanName"), price : vars("annualPlanPrice"), productId : vars("annualPlanProductId")
    // },
  ];
}
